<div
  *ngIf="window && eventService.getSettings$(window) | async as settings"
  class="stream overflowContainer mt-2"
  [ngClass]="settings.theme === 'light' ? 'theme-light' : 'theme-dark'"
  [style.backgroundColor]="settings.background"

>
  <div class="settings">
    <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" class="settings-icon"
            [class.open]="menuTrigger.menuOpen" [style.color]="isCurrentlyStreaming ? 'green' : '#fff'">
      <mat-icon>settings</mat-icon>
    </button>

    <mat-menu #menu="matMenu" [overlapTrigger]="false" (click)="$event.stopPropagation()">
      <app-settings [settings$]="eventService.getSettings$(window)" [window]="window" (click)="$event.stopPropagation()"
                    [event]="event" [eventMetadata]="eventMetadata"
                    (closeMenu)="menuTrigger.closeMenu()"></app-settings>
    </mat-menu>
  </div>
  <div class="content" (scroll)="streamBoxScrolled($event)" #streamBox>
    <p *ngFor="let paragraph of paragraphs" [style.font-size]="settings.fontSize + 'px'"
       [style.color]="settings.textColor" [style.line-height]="settings.fontSize + 'px'" [style.font-family]="settings.font">
      {{ paragraph.join(' ') }}    </p>
  </div>
</div>

<!--<div class='columns d-none d-lg-block' *ngIf='hasStenoPermission && window === 1'>-->
<!--  <div class='column is-12'>-->
<!--    <app-steno (text)='sendSteno($event)'></app-steno>-->
<!--  </div>-->
<!--</div>-->
